<template>
  <div class="reject" v-loading="loading">
    <div class="tit service-bimg">
      申请售后
      <span class="right" @click="contact">联系客服</span>
    </div>
    <div class="info">
      <ul class="info-tit">
        <li class="pro-info">商品信息</li>
        <li class="info_title">单价</li>
        <li class="info_title">数量</li>
        <li class="info_title">小计</li>
        <li class="info_title">实付</li>
      </ul>
      <div>
        <!-- 搭配购：将所有商品都带出来 -->
        <div v-if="collocationCommoditys && collocationCommoditys.length > 0">
          <ul class="info-con" v-for="(commodityOne, index) in collocationCommoditys" :key="index">
            <li class="pro-info">
              <div class="img-con" :style="{ 'background-image': `url(${commodityOne.itemImage})` }"></div>
              <div class="itemName">
                <span
                  v-if="commodityOne.extraMap && commodityOne.extraMap.activity && commodityOne.extraMap.activity.tag"
                  class="activityTag"
                  >{{ commodityOne.extraMap.activity.tag }}</span
                >
                <span v-if="commodityOne.extraMap && commodityOne.extraMap.collocationPurchase" class="activityTag"
                  >搭配购</span
                >
                <img
                  class="prizeTab"
                  style="width: 42px; height: 21px; margin: 0"
                  v-if="
                    (commodityOne.extraMap && commodityOne.extraMap.orderChannel === '3') ||
                      (commodityOne.extraMap && commodityOne.extraMap.orderChannel === 3)
                  "
                  src="@/assets/images/activity/lottery/prize.png"
                />
                {{ commodityOne.itemName }}
              </div>
              <p class="lh24" v-if="commodityOne.skuName">
                {{ commodityOne.skuName }}
              </p>
              <p class="lh24">
                {{
                  commodityOne.extraMap &&
                  commodityOne.extraMap.dealer &&
                  commodityOne.extraMap.dealer.dealerName &&
                  !commodityOne.extraMap.collocationPurchase
                    ? commodityOne.extraMap.dealer.dealerName
                    : ''
                }}
              </p>
            </li>
            <li class="info-content">{{ commodityOne.skuPrice | currency('￥', 2) }}</li>
            <li class="info-content">x{{ commodityOne.quantity }}</li>
            <li class="info-content">{{ (commodityOne.skuPrice * commodityOne.quantity) | currency('￥', 2) }}</li>
            <li class="info-content net">{{ commodityOne.fee | currency('￥', 2) }}</li>
          </ul>
        </div>
        <!-- 买赠 -->
        <div v-else-if="orderItemDtoListL && orderItemDtoListL.length > 0">
          <ul class="info-con" v-for="(commodityOne, index) in orderItemDtoListL" :key="index">
            <li class="pro-info">
              <div class="img-con" :style="{ 'background-image': `url(${commodityOne.itemImage})` }"></div>
              <div class="itemName">
                <span
                  v-if="commodityOne.extraMap && commodityOne.extraMap.activity && commodityOne.extraMap.activity.tag"
                  class="activityTag"
                  >{{ commodityOne.extraMap.activity.tag }}</span
                >
                <span v-if="commodityOne.extraMap && commodityOne.extraMap.bofogPurchase" class="activityTag"
                  >赠品</span
                >
                <img
                  class="prizeTab"
                  style="width: 42px; height: 21px; margin: 0"
                  v-if="
                    (commodityOne.extraMap && commodityOne.extraMap.orderChannel === '3') ||
                      (commodityOne.extraMap && commodityOne.extraMap.orderChannel === 3)
                  "
                  src="@/assets/images/activity/lottery/prize.png"
                />
                {{ commodityOne.itemName }}
              </div>
              <p class="lh24" v-if="commodityOne.skuName">
                {{ commodityOne.skuName }}
              </p>
              <p class="lh24" v-if="!(commodityOne.extraMap && commodityOne.extraMap.bofogPurchase)">
                {{
                  commodityOne.extraMap && commodityOne.extraMap.dealer && commodityOne.extraMap.dealer.dealerName
                    ? commodityOne.extraMap.dealer.dealerName
                    : ''
                }}
              </p>
            </li>
            <li class="info-content">{{ commodityOne.skuPrice | currency('￥', 2) }}</li>
            <li class="info-content">x{{ commodityOne.quantity }}</li>
            <li class="info-content">{{ (commodityOne.skuPrice * commodityOne.quantity) | currency('￥', 2) }}</li>
            <li class="info-content net">{{ commodityOne.fee | currency('￥', 2) }}</li>
          </ul>
        </div>
        <!-- 非搭配购 -->
        <ul v-else class="info-con">
          <li class="pro-info">
            <div class="img-con" :style="{ 'background-image': `url(${orderItemInfos.itemImage})` }"></div>
            <div class="itemName">
              <span
                v-if="
                  orderItemInfos.extraMap && orderItemInfos.extraMap.activity && orderItemInfos.extraMap.activity.tag
                "
                class="activityTag"
                >{{ orderItemInfos.extraMap.activity.tag }}</span
              >
              <img
                class="prizeTab"
                style="width: 42px; height: 21px; margin: 0"
                v-if="
                  (orderItemInfos.extraMap && orderItemInfos.extraMap.orderChannel === '3') ||
                    (orderItemInfos.extraMap && orderItemInfos.extraMap.orderChannel === 3)
                "
                src="@/assets/images/activity/lottery/prize.png"
              />
              {{ orderItemInfos.itemName }}
            </div>
            <p class="lh24" v-if="orderItemInfos.skuName">
              {{ orderItemInfos.skuName }}
            </p>
            <p class="lh24">
              {{
                orderItemInfos.extraMap && orderItemInfos.extraMap.dealer && orderItemInfos.extraMap.dealer.dealerName
                  ? orderItemInfos.extraMap.dealer.dealerName
                  : ''
              }}
            </p>
          </li>
          <li class="info-content">{{ orderItemInfos.skuPrice | currency('￥', 2) }}</li>
          <li class="info-content">x{{ orderItemInfos.quantity }}</li>
          <li class="info-content">{{ (orderItemInfos.skuPrice * orderItemInfos.quantity) | currency('￥', 2) }}</li>
          <li class="info-content net">{{ orderItemInfos.fee | currency('￥', 2) }}</li>
        </ul>
      </div>
    </div>
    <div class="tit">申请信息</div>
    <div class="apply-info">
      <el-form :model="formData" label-width="160px" ref="formData" :rules="rules">
        <el-form-item label="提交数量:" prop="num">
          <el-input-number v-model="formData.num" :show-message="false" :disabled="true"></el-input-number>
        </el-form-item>
        <!-- 赠品的退货退款 -->
        <div v-if="orderItemDtoListL && orderItemDtoListL.length > 0">
          <el-form-item label="售后类型:" prop="radio">
            <el-radio v-model="formData.radio" :label="0" v-if="!getItemType">
              <span>仅退款</span>
            </el-radio>
            <el-radio v-model="formData.radio" :label="1" v-else>
              <span>退货退款</span>
            </el-radio>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="售后类型:" prop="radio">
            <el-radio v-model="formData.radio" :label="0" v-if="radioRefund">
              <span>仅退款</span>
            </el-radio>
            <el-radio v-model="formData.radio" :label="1" v-else>
              <span>退货退款</span>
            </el-radio>
          </el-form-item>
        </div>

        <el-form-item label="售后原因:" prop="reason">
          <el-select v-model="formData.reason" placeholder="请选择售后原因">
            <el-option
              v-for="item in formData.options"
              :key="item.id"
              :label="item.label"
              :value="item.reason"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上传凭证:" v-if="!radioRefund" id="elUpload">
          <p class="lablename"><i class="pink">*</i></p>
          <el-upload
            action="#"
            :http-request="uploadAvatar"
            :multiple="true"
            list-type="picture-card"
            :limit="limitNum"
            :with-credentials="true"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-error="handleError"
            :on-exceed="handleExceed"
            :on-success="handleAvatarSuccess02"
            :before-upload="beforeAvatarUpload02"
          >
            <i class="el-icon-camera"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
          <p class="upload-tip">
            为了帮助您更好的解决问题,请上传照片
            (*最多可上传3张图片，每张图片大小不超过5M，支持bmp,gif,jpg,png,jpeg格式文件)
          </p>
          <div class="el-form-item__error" v-if="voucherFlag">请上传凭证</div>
        </el-form-item>
        <el-form-item label="问题描述:">
          <el-input type="textarea" placeholder="" v-model="formData.desc" :maxlength="300"></el-input>
          <p class="count">
            还可输入
            <span class="orange">{{ formData.desc.length == 0 ? '300' : `${300 - formData.desc.length}` }}</span
            >字
          </p>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSubmit('formData')" :loading="isSubmit">确认提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <section class="tips">
      <p>温馨提示:</p>
      <p>*商品寄回地址将在审核通过后以短信形式告知，或在申请记录中查询。</p>
      <p>*提交服务单后，售后专员可能与您电话沟通，请保持手机畅通。</p>
      <p>*售后处理成功后退款金额将原路返回到您的支付账户中。</p>
    </section>
  </div>
</template>
<script>
import { FormItem, InputNumber, Select, Option, Input, Button } from 'element-ui'
import after from '@/api/aftersale'
import myorder from '@/api/myorder'
import personApi from '@api/personcenter'

export default {
  name: 'reject-submit',
  components: {
    ElFormItem: FormItem,
    ElInputNumber: InputNumber,
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
    ElButton: Button
  },
  data() {
    return {
      collocationCommoditys: [],
      max: 0,
      limitNum: 3,
      loading: false,
      isShow: false,
      isSubmit: false,
      orderDetailInfo: [],
      orderItemInfos: [],
      orderInfo: {},
      proId: null,
      isReceived: false, // 判断是否收货
      imageUrl: '',
      formData: {
        num: null,
        radio: null,
        options: [
          {
            id: 1,
            label: '质量问题',
            reason: '质量问题'
          },
          {
            id: 2,
            label: '配件问题',
            reason: '配件问题'
          },
          {
            id: 3,
            label: '少件/漏发',
            reason: '少件/漏发'
          },
          {
            id: 4,
            label: '与商品描述不符',
            reason: '与商品描述不符'
          },
          {
            id: 5,
            label: '包装/商品残破',
            reason: '包装/商品残破'
          },
          {
            id: 6,
            label: '发票问题',
            reason: '发票问题'
          },
          {
            id: 7,
            label: '其它',
            reason: '其它'
          }
        ],
        reason: '',
        desc: ''
      },
      rules: {
        num: [{ required: true }],
        radio: [{ required: true, message: '请选择售后类型', trigger: 'change' }],
        reason: [{ required: true, message: '请选择售后原因', trigger: 'change' }],
        voucher: [{ required: true, message: '请上传凭证', trigger: 'change' }]
        // desc: [{ required: true, message: '请填写问题描述', trigger: 'change' }]
      },
      itemType: '',
      dialogImageUrl: '',
      dialogVisible: false,
      uploadUrls: this.BASE_URL + '/admin/upload_image',
      radioRefund: false,
      orderItemIds: [],
      pictures: [],
      imgList: [],
      voucherFlag: false,
      orderContractsId: '',
      orderItemDtoListL: []
    }
  },
  created() {
    this.getOrderDetailInfo()
  },
  computed: {
    /**
     * @descripttion: 如果是精品（包括是赠品）和收货了要退货退款
     * @Author: linyl
     * @Date: 2021-04-26 10:14:26
     * @param {*}
     * @return {*}
     */
    getItemType() {
      let f = this.orderItemDtoListL.some((item) => {
        // VEHICLE(0, "整车"),
        // SPARE(1, "备件"),
        // BOUTIQUE(2, "精品"),
        // COUPON(3, "卡券"),
        // OPTIONAL(4, "自采购商品")
        if (item.status === 5) {
          if (item.itemType === '1' || item.itemType === '2' || item.itemType === '4') {
            //  退货退款
            this.formData.radio = 1
            return true
          }
          this.formData.radio = 0
          // 退款
          return false
        } else {
          this.formData.radio = 0
          // 退款
          return false
        }
      })
      return f
    }
  },
  methods: {
    contact() {
      this.$feedback('请拨打客服热线 400-883-8888')
    },
    getOrderDetailInfo() {
      this.loading = true
      let orderParentId = this.$route.query.orderId ? this.$route.query.orderId : this.$route.query.proId
      // orderParentId = '891935205525291008'
      const orderContractId = this.$route.query.orderContractId
      this.proId = this.$route.query.proId
      this.itemType = Number(this.$route.query.itemType)
      this.collocationCommoditys = []
      // this.itemType = 8
      myorder.oredrdetail({ orderId: orderParentId }).then(
        (res) => {
          if (res.status === 200 || res.data) {
            // this.orderItemInfos = res.data.orderContracts[0].orderItemDtoList
            const proId = this.$route.query.proId
            let isCollocation = false

            // 判断是否是搭配购
            res.data.orderContracts.forEach((res2) => {
              // 如果商品有一个是搭配购，则需要整体退款;否则就是单独处理
              // 某个订单的商品
              res2.orderItemDtoList.forEach((o) => {
                if (o.extraMap && o.extraMap.activity && o.extraMap.activity.activityType === 2) {
                  isCollocation = true
                }
              })
            })
            // 订单的数组
            res.data.orderContracts.map((res) => {
              // 搭配购的处理（需要展示套餐中的所有商品）
              if (isCollocation) {
                this.collocationCommoditys = [...this.collocationCommoditys, ...res.orderItemDtoList]
                this.orderItemInfos = res.orderItemDtoList[0]
                // res.orderItemDtoList.forEach((o) => {
                //   this.orderItemIds.push(o.id)
                // })
                res.orderItemDtoList.forEach((order) => {
                  this.orderItemDtoListL.push(order)
                })
                // 非搭配购的处理
              } else {
                res.orderItemDtoList.forEach((order) => {
                  this.orderItemDtoListL.push(order)
                })
                // 判断是否是赠品
                let gift = this.orderItemDtoListL.some(function(fitem) {
                  if (
                    fitem.extraMap.bofogPurchase !== null ||
                    fitem.extraMap.bofogPurchase !== '' ||
                    fitem.extraMap.bofogPurchase !== undefined
                  ) {
                    return true
                  }
                })
                if (!gift) {
                  this.orderItemDtoListL = []
                }
                if (String(res.id) === String(orderContractId)) {
                  res.orderItemDtoList.map((item) => {
                    if (item.id === String(proId)) {
                      this.orderItemInfos = item
                    }
                  })
                  // this.orderItemIds.push(this.orderItemInfos.id)
                }
              }
            })
            // 如果有买赠就把买赠的商品id添加到orderItemIds
            if (this.orderItemDtoListL.length === 0) {
              this.orderItemIds.push(this.orderItemInfos.id)
            } else {
              this.orderItemDtoListL.forEach((item) => {
                this.orderItemIds.push(item.id)
              })
            }
            this.formData.num = Number(this.orderItemInfos.quantity)
            this.max = this.formData.num

            this.orderContractsId = this.orderItemInfos.orderContractId
            /*
                 itemType：
             *   VEHICLE(0, "整车"),
                SPARE(1, "备件"),
                BOUTIQUE(2, "精品"),
                COUPON(3, "卡券"),
                OPTIONAL(4, "自采购商品");
             */

            // 售后类型的判断
            // 是搭配购【只要有一个商品是备件或精品，则可能需要退货退款；其他情况仅退货】
            if (isCollocation) {
              // 如果有一个商品的状态是5(已完成)，且商品类型为1、2、3则退货退款  其他情况都是退款
              // 默认情况是仅退款
              this.formData.radio = 0
              this.radioRefund = true
              // 满足下面的条件就是：退货退款
              res.data.orderContracts.forEach((o) => {
                o.orderItemDtoList.forEach((item5) => {
                  // 状态为已完成
                  if (item5.status === 5) {
                    // 退货退款
                    if (
                      item5.itemType === '1' ||
                      item5.itemType === '2' ||
                      item5.itemType === '4' ||
                      item5.itemType === 1 ||
                      item5.itemType === 2 ||
                      item5.itemType === 4
                    ) {
                      this.formData.radio = 1
                      this.radioRefund = false
                    }
                  }
                })
              })
              // res.data.orderContracts[0].orderItemDtoList.forEach((item5) => {
              //   // 状态为已完成
              //   if (item5.status === 5) {
              //     // 退货退款
              //     if (
              //       item5.itemType === '1' ||
              //       item5.itemType === '2' ||
              //       item5.itemType === '4' ||
              //       item5.itemType === 1 ||
              //       item5.itemType === 2 ||
              //       item5.itemType === 4
              //     ) {
              //       this.formData.radio = 1
              //       this.radioRefund = false
              //     }
              //   }
              // })
              this.loading = false
              // 不是搭配购:判断逻辑1、如果状态为5(已完成)且商品类型为1、2、4则是退货退款  其他情况都是退款
            } else {
              this.loading = false
              if (this.orderItemInfos.status === 5) {
                if (
                  this.itemType === '1' ||
                  this.itemType === '2' ||
                  this.itemType === '4' ||
                  this.itemType === 1 ||
                  this.itemType === 2 ||
                  this.itemType === 4
                ) {
                  //  退货退款
                  this.formData.radio = 1
                  this.radioRefund = false
                  return true
                }
                this.formData.radio = 0
                this.radioRefund = true
                // 退款
                return false
              } else {
                this.formData.radio = 0
                this.radioRefund = true
                // 退款
                return false
              }

              // 下面是之前的判断逻辑
              // switch (this.itemType) {
              //   case 1:
              //   case 2:
              //     if (this.orderItemInfos.status === 1 || this.orderItemInfos.status === 2) {
              //       this.formData.radio = 0
              //       this.radioRefund = true
              //     }
              //     if (
              //       this.orderItemInfos.status === 3 ||
              //       this.orderItemInfos.status === 4 ||
              //       this.orderItemInfos.status === 5
              //     ) {
              //       this.formData.radio = 1
              //       this.radioRefund = false
              //     }
              //     break
              //   case 3:
              //     this.formData.radio = 0
              //     this.radioRefund = true
              //     break
              //   default:
              //     this.formData.radio = 0
              //     this.radioRefund = true
              // }
            }
          }
        },
        () => {
          this.loading = false
        }
      )
    },
    onSubmit(formName) {
      if (!this.radioRefund) {
        if (this.pictures.length > 0) {
          this.voucherFlag = false
        } else {
          this.voucherFlag = true
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.voucherFlag) {
            let data = {
              orderItemIds: this.orderItemIds,
              aftermarketType: this.formData.radio,
              cause: this.formData.reason,
              desc: this.formData.desc,
              fileUrl: this.pictures,
              contractId: this.orderContractsId,
              orderId: this.$route.query.orderId
            }
            after
              .refundOrder(data)
              .then((res) => {
                if (res.status === 200) {
                  this.isSubmit = true
                  this.$router.push({ name: 'submitSuccess' })
                } else {
                  this.$feedback(res.message)
                }
              })
              .catch((err) => {
                this.$feedback(err.message)
              })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    handleRemove(file, fileList) {
      // 移除
      let indexFlag = -1
      this.imgList.forEach((item, i) => {
        if (file.uid === item) {
          indexFlag = i
        }
      })
      this.pictures = this.pictures.filter((item, index) => {
        return index !== indexFlag
      })
    },
    handlePictureCardPreview(file) {
      // 预览
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleError(err, file, fileList) {
      // 上传失败
      this.$message(err)
    },
    beforeAvatarUpload02(file) {
      // 文件上传之前调用做一些拦截限制
      const isJPG = true
      const isLt2M = file.size / 1024 / 1024
      if (isLt2M > 3) {
        this.$feedback('上传图片大小不能超过3MB!')
        return false
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess02(res, file) {
      // 图片上传成功,图片数组添加
    },
    handleExceed(files, fileList) {
      this.$message('最多上传3张图片哦！')
    },
    uploadAvatar(file) {
      this.imgList.push(file.file.uid)
      this.updateLoading = true
      let form = new window.FormData()
      form.append('file', file.file, file.file.name)
      personApi.upLoadImg(form).then(
        (res) => {
          if (res.status === 200) {
            this.pictures.push(res.data)
            if (this.pictures.length > 0) {
              this.voucherFlag = false
            }
          }
        },
        (res) => {
          this.$feedback(res.message)
        }
      )

      // 上传之前要先请求上传头像接口 （调UAA）/api/v1/cuz/upload
    }
  }
}
</script>
<style lang="scss">
#elUpload {
  .el-dialog {
    width: 540px !important;
  }
  .el-dialog__body {
    img {
      width: 500px !important;
      height: auto !important;
    }
  }
}
</style>
<style lang="scss">
$box-shadow: 0px 1px 0px 0px rgba(224, 224, 224, 1);
.upload-tip {
  margin-top: 12px;
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.reject {
  .el-radio__input.is-checked + .el-radio__label {
    color: #c6001f;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #c6001f;
    background: #c6001f;
  }
  width: 1085px;
  text-align: left;
  margin-bottom: 30px;
  font-size: 18px;
  .tit {
    width: 100%;
    height: 40px;
    text-align: left;
    font-weight: normal;
    color: #333;
    .right {
      float: right;
      margin-right: 22px;
      cursor: pointer;
    }
  }
  .service-bimg {
    width: 100%;
    background: url('../../assets/images/after/contact.png') no-repeat 90% 2px;
    background-size: 23px;
  }
  .info {
    width: 100%;
    background: #fff;
    // height: 236px;
    color: #333;
    margin-bottom: 20px;
    font-size: 16px;
    .info-tit {
      height: 49px;
      line-height: 49px;
      box-shadow: $box-shadow;
      padding-left: 25px;
    }
    .info_title,
    .info-content {
      float: left;
      width: 15%;
      text-align: center;
    }
    .pro-info {
      width: 40%;
      text-align: left;
      float: left;
      .lh24 {
        line-height: 24px;
      }
      .img-con {
        margin-right: 14px;
        height: 143px;
        width: 202px;
        background-size: contain;
        background-repeat: no-repeat;
        float: left;
      }
      h3 {
        font-size: 18px;
        font-weight: normal;
        margin: 13px 0 10px;
      }
      .itemName {
        font-size: 18px;
        font-weight: normal;
        margin: 13px 0 10px;
        white-space: nowrap;
      }
      .activityTag {
        padding: 0 3px;
        color: #fff;
        background: #df3d36;
        font-weight: 400;
        height: 21px;
        font-size: 16px;
        font-family: PingFangSC;
        font-weight: 500;
        line-height: 21px;
        margin-right: 5px;
      }
      .prizeTab {
        padding: 0 3px;
        height: 21px;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
    .info-con {
      height: 143px;
      padding: 22px 0 22px 25px;
      box-sizing: content-box;
      box-shadow: $box-shadow;
      .net {
        color: #c6001f;
      }
    }
    .info-content {
      line-height: 143px;
      font-size: 18px;
    }
  }
  .apply-info {
    background: #fff;
    padding: 30px 30px 100px;
    border-bottom: 1px solid rgba(224, 224, 224, 1);
    // position: relative;
    ::deep {
      .el-radio__label {
        font-size: 16px;
      }
      input {
        font-size: 16px;
        border-radius: 0;
      }
      textarea {
        font-size: 14px;
        border-radius: 0;
      }
    }
    .el-form-item__label {
      font-size: 18px;
    }
    .el-textarea__inner {
      position: relative;
      height: 220px;
    }
    .el-radio {
      display: block;
      height: 40px;
      margin-left: 0;
    }
    .el-radio__input {
      display: inline-block;
      margin-top: 13px;
    }
    .el-radio__label {
      width: 360px;
      display: inline-block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      span {
        display: block;
      }
    }
    .count {
      position: absolute;
      bottom: 5px;
      right: 25px;
      color: #666;
      font-size: 14px;
      .orange {
        color: #ff7010;
      }
    }
    .lablename {
      position: absolute;
      left: -99px;
      top: 0;
      font-size: 18px;
      .pink {
        color: #f56c6c;
        margin-right: 4px;
      }
    }
    .margint {
      margin: 10px 0 20px 100px;
      .grey {
        color: #666;
        margin-right: 10px;
      }
      .con {
        width: 272px;
        margin-right: 90px;
      }
    }
    .el-button--default {
      width: 133px;
      height: 40px;
      background: #333;
      color: #fff;
      font-size: 18px;
      border: 0;

      left: 40%;
      top: 20px;
      cursor: pointer;
      border-radius: 0;
    }
  }
  .tips {
    margin: 30px 0px 0;
    height: 109px;
    padding: 15px 0 0 40px;
    background: rgba(247, 165, 0, 0.1) url('../../assets/images/after/tips.png') no-repeat 16px 15px;
    background-size: 16px;
    border: 1px solid rgba(247, 165, 0, 0.35);
    text-align: left;
    font-size: 14px;
    p {
      margin-bottom: 5px;
    }
  }
}
</style>
